<mat-chip-listbox>
  <mat-chip-option
    *ngFor="let device of devices"
    class="body-2"
    [selected]="device.isSelected"
    [ngClass]="{
      'bg-accent-100': !device.isSelected,
      'bg-accent selected': device.isSelected
    }"
    (selectionChange)="changeSelection(device)">
    {{ device.label }}
  </mat-chip-option>
</mat-chip-listbox>
